import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CreateLeadRequestPayload } from './models';

@Injectable({
  providedIn: 'root'
})
export class LeadRequestService {
  constructor(private http: HttpClient) {}

  create(payload: CreateLeadRequestPayload): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/lead-requests`, payload);
  }
}

